import { ACTION } from './evaluation_purpose_actions';

const initialState = {
  evaluationPurposes: [],
  loading: false,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST_EVALUATION_PURPOSE}_PENDING`:
      return {
        ...state,
        loading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST_EVALUATION_PURPOSE}_FULFILLED`:
      return {
        ...state,
        loading: false,
        evaluationPurposes: action.payload,
      };
    case `${ACTION.LIST_EVALUATION_PURPOSE}_REJECTED`:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};






// WEBPACK FOOTER //
// ./src/redux/references/evaluation_purpose_reducer.js